import type {
  FeatureRef,
  FeatureCollectionId,
} from '@src/types/featureCollections.ts';
import {createReducer} from '@reduxjs/toolkit';
import {
  setVisibleCollection,
  selectCollectionFeatureRefs,
  setFeatureDetailsRef,
  setShowQuotaManagement,
} from '@src/actions/featureCollections.ts';

type FeatureCollectionsState = {
  featureDetailsRef: FeatureRef | null;
  selectedFeatureRefs: FeatureRef[] | null;
  showQuotaManagement: boolean;
  visibleCollectionId: FeatureCollectionId | null;
};

export const initialState: FeatureCollectionsState = {
  // The feature ref to show details for
  featureDetailsRef: null,

  // The currently selected features.
  selectedFeatureRefs: [],

  // Whether we're in quota management mode
  showQuotaManagement: false,

  // The hash ID of the currently visible collection.
  visibleCollectionId: null,
};

export default createReducer(initialState, builder => {
  builder.addCase(selectCollectionFeatureRefs, (state, {payload}) => {
    state.selectedFeatureRefs = payload ?? [];
  });

  builder.addCase(setFeatureDetailsRef, (state, {payload}) => {
    state.featureDetailsRef = payload ?? null;
  });

  builder.addCase(setShowQuotaManagement, (state, {payload}) => {
    state.showQuotaManagement = !!payload;
  });

  builder.addCase(setVisibleCollection, (state, {payload}) => {
    state.visibleCollectionId = payload ?? null;
  });
});
